var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#328332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99381 9.31106L5.21325 8.9865L8.99325 6.84787V9.31106H8.99381ZM8.99381 11.8198V15.7236C7.67925 13.6772 6.23025 11.4249 5.0625 9.60187C6.44063 10.3781 7.8795 11.1892 8.99381 11.8198ZM8.99381 6.15656L5.0625 8.35031L8.99381 2.25V6.15656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7744 8.9865L8.99384 9.31106V6.84787L12.7744 8.9865ZM8.99384 11.8204C10.1076 11.1904 11.5459 10.3781 12.9246 9.60187C11.7568 11.4255 10.3078 13.6777 8.99384 15.723V11.8204ZM8.99384 6.15656V2.25L12.9246 8.35031L8.99384 6.15656Z",
    fill: "white",
    fillOpacity: 0.601
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99384 9.31113L12.7738 8.98657L8.99384 11.11V9.31113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.603,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99327 9.31113L5.21271 8.98657L8.99327 11.11V9.31113Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtc);
export default __webpack_public_path__ + "static/media/etc.35cd8c7224066ff04e7a8ae913011225.svg";
export { ForwardRef as ReactComponent };